import { z } from "zod";

/** CEP brasileiro — 8 digitos (aceita com ou sem hifen), normaliza so digitos. */
export const cepSchema = z
  .string()
  .trim()
  .transform((v) => v.replace(/\D/g, ""))
  .refine((v) => v.length === 8, "CEP deve ter 8 digitos");

export const optionalCepSchema = cepSchema
  .optional()
  .or(z.literal("").transform(() => undefined));
